<template>
  <div class="search-form p-2">
    <div class="col-sm-12 search-form-title">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <form
      @submit.prevent="onSubmit"
      @reset="onReset"
    >
      <div class="row">
        <div class="col-sm-6">
            <span class="span-title">
              {{ $t('trip_list.road_sec_from') }}
            </span>
            <input
                id="start"
                v-model="fromDate"
                type="date"
                class="form-control form-control-sm"
            />
        </div>
        <div class="col-sm-6">
            <span class="span-title">
              {{ $t('trip_list.road_sec_to') }}
            </span>
            <input
                id="end"
                v-model="toDate"
                type="date"
                class="form-control form-control-sm"
            />
        </div>
      </div>
      <div class="row">
          <open-contract-filter-multi-select
            :to="toDate"
            :from="fromDate"
            :show-only-my-contracts-option="true"
            @loading="loading=true"
            @loading-completed="loading=false"
            @company-selected="setCompany"
            @contracts-selected="setContracts"
          />
      </div>
      <div class="row">
        <div class="col-sm-6 pr-2">
            <span class="span-title mt-0">
              {{ $t('trip_list.vehicle') }}
            </span>
            <select
                id="vehicle"
                v-model="vehicle"
                class="form-select form-select-sm"
            >
                <option :value="-1">{{ $t('orders.select_status') }}</option>
                <option
                    v-for="v in vehicles"
                    :key="v.id"
                    :value="v.id"
                >
                    {{ v.make }} {{ v.vehicle_model }} {{ v.license_plate }}
                </option>
            </select>
        </div>
      </div>

      <div class="col-sm-12 button-container">
        <button type="reset" class="btn btn-danger form-button">
          {{ $t('ins_report.clear') }}
        </button>
          <button type="submit" class="btn btn-primary form-button" :disabled="!fromDate || !toDate">
              {{ $t('ins_report.search') }}
          </button>
      </div>
    </form>
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {timeUtils} from '../../mixins/TimeUtils'
import OpenContractFilterMultiSelect from "../../contract/OpenContractFilterMultiSelect";

export default {
    name: 'VehicleAllocationSearch',
    components: {OpenContractFilterMultiSelect},
    mixins: [restApi, timeUtils],
    data: function () {
        return {
            loading: false,
            vehicle: -1,
            company: null,
            vehicles: [],
            contracts: [],
            contractIds: [],
            fromDate: null,
            toDate: null,
        }
    },
    mounted: function () {
        this.fetchVehicles()
        this.toDate = this.getYesterday()
    },
    methods: {
        fetchVehicles: function () {
            this.loading = true
            this.restFetch(this.vehicleUrl, this.handleVehicles)
        },

        handleVehicles: function (response) {
            this.loading = false
            response.data && response.data.length > 0 && response.data.sort(function (a, b) {
                const nameA = a.make + a.vehicle_model + a.license_plate;
                const nameB = b.make + b.vehicle_model + b.license_plate;
                if (nameA.toUpperCase() < nameB.toUpperCase()) {
                    return -1;
                }
                if (nameA.toUpperCase() > nameB.toUpperCase()) {
                    return 1;
                }
                return 0;
            })

            this.vehicles = response.data
        },

        onSubmit: function () {
            var params = {}
            if (this.vehicle > 0) {
                params.vehicle = this.vehicle
            }
            if(this.contractIds && this.contractIds.length > 0) {
                params.contractIds = this.contractIds
            }
            if(this.company && this.company.id) {
                params.customer = this.company.id
            }
            if (this.fromDate !== null && this.fromDate.trim()) {
                params.from = this.fromDate
            }
            if (this.toDate !== null && this.toDate.trim()) {
                params.to = this.toDate
            }
            this.$emit('search', params)
        },

        setCompany: function (company) {
            this.company = company
        },

        setContracts: function (contracts) {
            this.contracts = contracts
            this.contractIds = []
            contracts.map(contract => {
                this.contractIds.push(contract.id)
            })
        },

        onReset: function () {
            this.vehicle = -1
            this.fromDate = null
            this.toDate = null
            this.company = null
            this.contracts = []
            this.contractIds = []
        }
    }
}
</script>

<style scoped>

</style>
